import { CaptionedImageFragment } from "graphql/generated-types";
import CaptionedImage from "./CaptionedImage";

type FullWidthImageBlockProps = {
	image: CaptionedImageFragment;
};

const FullWidthImage = ({ image }: FullWidthImageBlockProps) => {
	return <div className="w-full">{image && <CaptionedImage block={image} />}</div>;
};

export default FullWidthImage;
